module.exports = __webpack_public_path__ + "img/productActive-4.757d6b41.svg";